import { z } from 'zod';
export const StaffRole = z.enum(['ORGANIZER', 'STAFF_ATTENDANCE', 'STAFF_LUNCH', 'STAFF_SCANNER']);
export const LoginInput = z.object({
    email: z.string().email(),
    password: z.string().min(1),
});
export const LoginOutput = z.object({
    accessToken: z.string(),
    user: z.object({
        id: z.string().uuid(),
        email: z.string().email(),
        fullName: z.string(),
        role: StaffRole,
    }),
});
export const UpdateStaffNameInput = z.object({ fullName: z.string().min(1).max(100) });
//# sourceMappingURL=auth.js.map